module.exports = __webpack_public_path__ + "static/media/CircularPro-Book.3dcc7e40.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Book.otf
// module id = 104
// module chunks = 0